// extracted by mini-css-extract-plugin
export var body = "ProPageLayout-module__body___wgsZl";
export var topoBackground = "ProPageLayout-module__topoBackground___Zo5Hx";
export var panel = "ProPageLayout-module__panel____hHIN";